import { Phone, Mail, MapPin, MessageSquare } from "lucide-react";

export default function ContactSection() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-28 lg:py-40 bg-[#161616]"
    >
      {/* Top divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/15 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-24 text-center">
          <p className="font-accent italic text-gold text-base tracking-widest mb-4">
            Nous joindre
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
            Contact
          </h2>
          <div className="gold-line w-24 mx-auto mt-8" />
        </div>

        {/* Contact Cards - refined */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {/* Call */}
          <a
            href="tel:0676806203"
            data-testid="contact-phone"
            className="group relative flex flex-col items-center gap-6 p-10 bg-[#1C1C1C] border border-white/[0.08] hover:border-gold/30 transition-all duration-700 overflow-hidden"
          >
            <div className="absolute top-0 left-0 w-8 h-8 border-l border-t border-gold/0 group-hover:border-gold/30 transition-all duration-700" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-r border-b border-gold/0 group-hover:border-gold/30 transition-all duration-700" />
            <div className="w-14 h-14 flex items-center justify-center border border-gold/20 group-hover:border-gold/50 group-hover:bg-gold/5 transition-all duration-500">
              <Phone size={18} className="text-gold/70 group-hover:text-gold" strokeWidth={1.2} />
            </div>
            <div className="text-center">
              <p className="text-white/30 text-[10px] uppercase tracking-[0.25em] mb-3">
                Appeler
              </p>
              <p className="text-white text-base tracking-[0.1em] group-hover:text-gold transition-colors duration-500">
                06 76 80 62 03
              </p>
            </div>
          </a>

          {/* SMS */}
          <a
            href="sms:0676806203"
            data-testid="contact-sms"
            className="group relative flex flex-col items-center gap-6 p-10 bg-[#1C1C1C] border border-white/[0.08] hover:border-gold/30 transition-all duration-700 overflow-hidden"
          >
            <div className="absolute top-0 left-0 w-8 h-8 border-l border-t border-gold/0 group-hover:border-gold/30 transition-all duration-700" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-r border-b border-gold/0 group-hover:border-gold/30 transition-all duration-700" />
            <div className="w-14 h-14 flex items-center justify-center border border-gold/20 group-hover:border-gold/50 group-hover:bg-gold/5 transition-all duration-500">
              <MessageSquare size={18} className="text-gold/70 group-hover:text-gold" strokeWidth={1.2} />
            </div>
            <div className="text-center">
              <p className="text-white/30 text-[10px] uppercase tracking-[0.25em] mb-3">
                SMS
              </p>
              <p className="text-white text-base tracking-[0.1em] group-hover:text-gold transition-colors duration-500">
                06 76 80 62 03
              </p>
            </div>
          </a>

          {/* Email */}
          <a
            href="mailto:warnervtc@gmail.com"
            data-testid="contact-email"
            className="group relative flex flex-col items-center gap-6 p-12 bg-[#0C0C0C] border border-white/[0.04] hover:border-gold/30 transition-all duration-700 overflow-hidden"
          >
            <div className="absolute top-0 left-0 w-8 h-8 border-l border-t border-gold/0 group-hover:border-gold/30 transition-all duration-700" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-r border-b border-gold/0 group-hover:border-gold/30 transition-all duration-700" />

            <div className="w-16 h-16 flex items-center justify-center border border-gold/20 group-hover:border-gold/50 group-hover:bg-gold/5 transition-all duration-500">
              <Mail size={20} className="text-gold/70 group-hover:text-gold" strokeWidth={1.2} />
            </div>
            <div className="text-center">
              <p className="text-white/30 text-[10px] uppercase tracking-[0.25em] mb-3">
                Email
              </p>
              <p className="text-white text-sm tracking-wider group-hover:text-gold transition-colors duration-500">
                warnervtc@gmail.com
              </p>
            </div>
          </a>

          {/* Location */}
          <div
            data-testid="contact-location"
            className="group relative flex flex-col items-center gap-6 p-12 bg-[#0C0C0C] border border-white/[0.04] hover:border-gold/30 transition-all duration-700 overflow-hidden"
          >
            <div className="absolute top-0 left-0 w-8 h-8 border-l border-t border-gold/0 group-hover:border-gold/30 transition-all duration-700" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-r border-b border-gold/0 group-hover:border-gold/30 transition-all duration-700" />

            <div className="w-16 h-16 flex items-center justify-center border border-gold/20 group-hover:border-gold/50 group-hover:bg-gold/5 transition-all duration-500">
              <MapPin size={20} className="text-gold/70 group-hover:text-gold" strokeWidth={1.2} />
            </div>
            <div className="text-center">
              <p className="text-white/30 text-[10px] uppercase tracking-[0.25em] mb-3">
                Basé à
              </p>
              <p className="text-white text-lg tracking-wider">
                Saint-Renan
              </p>
              <p className="text-white/25 text-xs mt-1 tracking-wide">
                Finistère, Bretagne
              </p>
            </div>
          </div>
        </div>

        {/* Availability */}
        <div className="mt-20 text-center">
          <div className="inline-block px-8 py-4 border border-gold/10">
            <p className="font-accent italic text-white/30 text-base tracking-wide">
              Disponible 7j/7 — Réservation conseillée
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
